import { Trigger } from "../interfaces/analytics/enums/Trigger";
import { analyticsApiBaseUrl } from "./apiBaseUrl";
export class AnalyticsApi {
    constructor() {
        this.baseUrl = `${analyticsApiBaseUrl}/analytics`;
    }
    async triggerAction(body) {
        const response = await fetch(this.baseUrl, {
            method: "POST",
            body: JSON.stringify(body)
        });
        if (!response.ok) {
            return "";
        }
        const responseBody = await response.json();
        return responseBody.id;
    }
    async triggerCustomerGoesToCheckoutFromRecommendation(data) {
        return await this.triggerAction(Object.assign(Object.assign({}, data), { customerName: "", trigger: Trigger.CustomerGoesToCheckoutFromRecommendation }));
    }
    async triggerCustomerGoesToViewProductPage(data) {
        return await this.triggerAction(Object.assign(Object.assign({}, data), { customerName: "", trigger: Trigger.CustomerGoesToViewProductPage }));
    }
}
